import { BehaviorSubject, Observable } from 'rxjs';

export interface ScrolledState {
  atScrollTop: boolean;
  scrolledDown: boolean;
}

export class ScrolledObserver {
  private currentScrollPosition = 0;
  private lastScrollPosition = 0;

  private scrollState$ = new BehaviorSubject<ScrolledState>({
    atScrollTop: true,
    scrolledDown: false,
  });

  get scrollState(): Observable<ScrolledState> {
    return this.scrollState$.asObservable();
  }

  constructor() {
    window.addEventListener('scroll', () => {
      this.currentScrollPosition = scrollY;
      this.emitNewScrollState();
      this.lastScrollPosition = this.currentScrollPosition;
    });
  }

  private emitNewScrollState() {
    this.scrollState$.next({
      atScrollTop: this.isAtScrollTop(),
      scrolledDown: this.hasScrolledDown(),
    });
  }

  private isAtScrollTop(): boolean {
    return this.lastScrollPosition < 50;
  }

  private hasScrolledDown() {
    return this.lastScrollPosition < this.currentScrollPosition;
  }
}
